import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { AuditsIndexRoute } from 'src/pages/Audit/AuditIndexPage'
import {
  StandardButton,
  StandardButtonSize,
  StandardButtonVariant,
} from 'src/components/Reusable/Buttons'
import {
  AuditBotEmptyButtonContainer,
  AuditBotEmptyContainer,
  AuditBotEmptyIcon,
  AuditBotEmptyTitle,
  Line,
  LineContainer,
  LineP,
} from './AuditBotModal.styles'

export const AuditBotModalEmptyState = ({
  onHide,
  text,
}: {
  onHide: () => void
  text: string
}): JSX.Element => {
  const navigate = useNavigate()
  const params = useParams()
  const url = `/${params.pageContext}/${AuditsIndexRoute}`

  return (
    <AuditBotEmptyContainer>
      <AuditBotEmptyTitle>
        <AuditBotEmptyIcon />
        {text}
      </AuditBotEmptyTitle>
      <AuditBotEmptyButtonContainer>
        <StandardButton
          buttonSize={StandardButtonSize.MEDIUM}
          variant={StandardButtonVariant.PRIMARY}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            onHide()
            navigate(url)
          }}
        >
          Set up an Audit
        </StandardButton>
      </AuditBotEmptyButtonContainer>
    </AuditBotEmptyContainer>
  )
}

export const LineText = ({ text }: { text: string }): JSX.Element => (
  <LineContainer>
    <Line />
    <LineP>{text}</LineP>
    <Line />
  </LineContainer>
)
